// extracted by mini-css-extract-plugin
export default {"container":"ProfileManagement_container__V9Wh0","sectionTitle":"ProfileManagement_sectionTitle__NCRSH"};